/* eslint-disable complexity */
import { UserDetails } from "@moodys/mdc-frontend.utils.event-bus";

import { MenuLink } from "./model";
import { ProductAuthorizationsProps } from "./useProductAuthorization";

export interface FilterMenuModelParams {
  node: MenuLink.All;
  productAuthorizations: ProductAuthorizationsProps;
  hasEsgDocumentsContent: boolean;
  isNotificationSettingsEnabled?: boolean;
}

export const filterMenuModel = ({
  node,
  productAuthorizations,
  hasEsgDocumentsContent,
  isNotificationSettingsEnabled,
}: FilterMenuModelParams) => {
  if (node?.nodeType === "divider") {
    return true;
  }
  if (node.titleKey === "esgDownloads") {
    return hasEsgDocumentsContent;
  }
  if (node.titleKey === "notifications" && !isNotificationSettingsEnabled) {
    return false;
  }
  return (node.requiredProductAuthorizations ?? [])?.every(
    (requiredProductAuth) => productAuthorizations?.[requiredProductAuth]
  );
};

export const getUserInitials = (userDetails?: UserDetails): string => {
  return (
    (userDetails?.given_name?.slice(0, 1) ?? "") +
    (userDetails?.family_name?.slice(0, 1) ?? "")
  ).trim();
};
